export default __webpack_public_path__ + "fonts/41a7f4e44e54b710c95c86217de7809b.svg";